import { Button, message, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";

import arrowDown from "../../assets/icons/arrow-down12.png";
import search from "../../assets/icons/search-normal.svg";
import { controller } from "../../controller";

export default function CreateBoardFormManual({ setSelectedPatients, handleCreateBoard, isCreatingBoard }) {
  const [patientSelectOptions, setPatientSelectOptions] = useState([]);
  const [isGettingPatients, setIsGettinPatients] = useState(false);

  // Get office patients
  useEffect(function () {
    async function getAllPatients() {
      try {
        setIsGettinPatients(true);

        const response = await controller.getPatient2();

        setPatientSelectOptions(response.map((patient) => ({ label: `${patient.first_name} ${patient.last_name}`, value: patient.id })));
      } catch (err) {
        message.error("Something went wrong while getting patients");
        console.error(err);
      } finally {
        setIsGettinPatients(false);
      }
    }
    getAllPatients();
  }, []);

  if (isGettingPatients)
    return (
      <div style={{ display: "flex", padding: "20px 0", alignItems: "center", justifyContent: "center" }}>
        <Spin />
      </div>
    );

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      <div>
        <p style={{ fontSize: 16, fontWeight: 400 }}>Add Patient</p>

        <Select
          mode="multiple"
          showSearch={true}
          options={patientSelectOptions}
          maxTagCount="responsive"
          onChange={(v) => setSelectedPatients(v)}
          style={{ width: "100%", display: "flex", alignItems: "center" }}
          className="custom-style-selection-manual-board"
          placeholder="Select Patient"
          prefix={<img src={search} alt="search" style={{ width: 20 }} />}
          suffixIcon={<img src={arrowDown} alt="search" />}
        />
      </div>

      <Button style={{ width: "100%" }} type="primary" onClick={() => handleCreateBoard()} loading={isCreatingBoard}>
        Done
      </Button>
    </div>
  );
}
